import {
    // MyReactComponent
} from '../components';

export const componentList = {
    // 'MyReactComponent': MyReactComponent,
};